// extracted by css-extract-rspack-plugin
export default {"analyticsLectureStudent__heading":"RHOuY","analyticsLectureStudent__pagination":"eRkK2","analyticsLectureStudent__table":"AUVv_"};